module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAMAAACelLz8AAAAY1BMVEUAAAA9ftM+fdNAgNM8ftM+gNM+ftI+f9M+ftM+f9M9f9M+ftM9f9Q9f9M+ftM9f9M8ftU5ftM9f9M9f9Q9gNM9f9M/gNM8f9M2edA1gNU+f9M9f9I+gNM+ftI9gNM9ftU+f9MBcZT4AAAAIHRSTlMAliw0MvaIj/Po3dbDvn9nIBnupqOfblATDKmJgHdcT4ZalN8AAACOSURBVCjP5c5JDsIwEETRiuNgO4OHzGHs+58S1I6CkbyANX/7pFLhqCCuwNF3pKy1XUKnWHiR9MFfE6KYeA9uMgYybds2KZUUA90BbHnSdV2bPHGftAghbnlSs5vPeeL+lIxqdhqHnRplmCTWimkCJia9omQKQM90ARRTD3im7jEQk3ZOM9G4dL8+lFXsCU5pM24B6+jzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/wsicon.png
// module id = VAFO
// module chunks = 1